var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCycle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6598 5.00038C13.3217 4.0449 12.7471 3.19064 11.9895 2.51732C11.232 1.844 10.3162 1.37355 9.32765 1.14988C8.3391 0.92621 7.31 0.956603 6.33638 1.23823C5.36275 1.51985 4.47634 2.04352 3.75984 2.76038L0.666504 5.66704M15.3332 8.33371L12.2398 11.2404C11.5233 11.9572 10.6369 12.4809 9.6633 12.7625C8.68967 13.0441 7.66058 13.0745 6.67203 12.8509C5.68348 12.6272 4.7677 12.1568 4.01015 11.4834C3.25259 10.8101 2.67795 9.95585 2.33984 9.00038M15.333 12.3337V8.33374H11.333M0.666504 1.66724V5.66724H4.6665",
    stroke: "#C3362E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCycle);
export default __webpack_public_path__ + "static/media/cycle.20f2f0bb851fa2f837615b22cd6eaf49.svg";
export { ForwardRef as ReactComponent };